import React from 'react';
import E from 'wangeditor';
import styles from './Index.less';

class RichText extends React.Component {
  constructor(props) {
    super(props);

    this.editor = null;
    this.oldInitialValue = null;

    this.div1 = `#div1${+new Date()}${Math.floor(Math.random() * 1000)}`;
    this.div2 = `#div2${+new Date()}${Math.floor(Math.random() * 1000)}`;
  }

  componentDidMount() {
    const { onChange, content, onBlur, initialValue } = this.props;
    // const elem = this.richTextEditor;
    const editor = new E(this.div1, this.div2);
    // const editor = new E(elem);
    editor.customConfig.menus = [
      'head', // 标题
      'bold', // 粗体
      'fontSize', // 字号
      'fontName', // 字体
      'italic', // 斜体
      'underline', // 下划线
      'strikeThrough', // 删除线
      'foreColor', // 文字颜色
      'backColor', // 背景颜色
      'link', // 插入链接
      'list', // 列表
      'justify', // 对齐方式
      'quote', // 引用
      'emoticon', // 表情
      // 'image',  // 插入图片
      'table', // 表格
      'video', // 插入视频
      'code', // 插入代码
      'undo', // 撤销
      'redo', // 重复
    ];
    editor.customConfig.withCredentials = true;
    editor.customConfig.onchange = html => {
      if (onChange) {
        onChange(html);
      }
    };
    editor.customConfig.zIndex = 100;
    editor.customConfig.onblur = html => {
      if (onBlur) {
        onBlur(html);
      }
    };
    editor.create();

    if (initialValue) {
      editor.txt.html(initialValue);
      this.oldInitialValue = initialValue;
    } else {
      editor.txt.html(content ? `<div>${content}</div>` : content);
      this.oldInitialValue = content;
    }

    this.editor = editor;
  }

  componentWillReceiveProps(nextProps) {
    const { initialValue } = nextProps;

    if (this.oldInitialValue !== initialValue) {
      if (initialValue) {
        this.editor.txt.html(initialValue === '' ? initialValue : `<div>${initialValue}</div>`);
      }

      this.oldInitialValue = initialValue;
    }
  }

  render() {
    return (
      // <div
      //   ref={editorElem => {
      //     this.richTextEditor = editorElem;
      //   }}
      //   style={{ textAlign: 'left' }}
      // />
      <div>
        <div id={this.div1.slice(1)} className={styles.toolbar} />
        <div id={this.div2.slice(1)} className={styles.content} />
      </div>
    );
  }
}

export default RichText;



// WEBPACK FOOTER //
// ./src/components_business/RichText/Index.js